module.exports = __webpack_public_path__ + "img/calendar-plus.1ccdf5bb.svg";